/**
 * A stack (push/pop) of a limited size.
 * As the stack grows, items fall off the end to keep
 * the size from exceeding the maximum set at creation time.
 */
export class LimitedLengthStack<T> {
  constructor(public readonly maxLength: number) {}

  private arr: Array<T> = [];

  push(item: T) {
    if (this.arr.length === this.maxLength) this.arr.pop();
    this.arr.unshift(item);
  }

  pop(): T | undefined {
    return this.arr.shift();
  }

  peek(index = 0): T | undefined {
    return this.arr[index];
  }

  get length() {
    return this.arr.length;
  }
}
